/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {ActionType, createAction} from 'typesafe-actions';

export const applicationStarted = createAction('APPLICATION_STARTED')();

export type ActionTypes =
	ActionType<typeof applicationStarted>;
